import React from 'react';
import { DEFAULT_NEW_FOLDER_NAME } from '../../utils/constants';
import EditableDashboardFolder from './EditableDashboardFolder';
import useCreateFolder from '../../utils/useCreateFolder';
import { useAppDispatch } from '../../../../redux/hooks';
import { IDashboardFolderFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { populatePublishedFolder } from '../../../../redux/slices/dashboards/dashboardInstance';

interface IProps {
  parentFolderId: string | null;
  setCreateFolderMode?: (createMode: boolean) => void;
}

const CreateDashboardFolder = ({
  parentFolderId,
  setCreateFolderMode,
}: IProps) => {
  const dispatch = useAppDispatch();

  const cancelCreateMode = () => {
    setCreateFolderMode?.(false);
  };

  const handleSubmitNewFolder = (newFolder: IDashboardFolderFieldsFragment) => {
    dispatch(populatePublishedFolder({ publishedFolder: newFolder }));
    cancelCreateMode();
  };

  const createFolder = useCreateFolder({
    parentFolderId,
    onSubmit: handleSubmitNewFolder,
    onError: () => cancelCreateMode(),
  });

  return (
    <EditableDashboardFolder
      value={DEFAULT_NEW_FOLDER_NAME}
      onSubmit={createFolder}
      onCancel={() => cancelCreateMode()}
      allowSameValue={true}
    />
  );
};

export default CreateDashboardFolder;
